// Lesson 1_1
export const snakeDataSet1 = [
  {
    engWord:'Hello',
    rusWord:'Здравствуйте',
    correct:false
  },
  {
    engWord:'Hi',
    rusWord:'Привет',
    correct:false
  },
  {
    engWord:'How are you?',
    rusWord:'Как дела?',
    correct:false
  },
  {
    engWord:'Excellent',
    rusWord:'Отлично',
    correct:false
  },
  {
    engWord:'Good',
    rusWord:'Хорошо',
    correct:false
  }
]

/* export const snakeDataSet1 = [
  {
    engWord:'I',
    rusWord:'Я',
    correct:false
  },
  {
    engWord:'He',
    rusWord:'Он',
    correct:false
  }
] */

// Lesson 1_1
export const snakeDataSet2 = [
  {
    engWord:'Russia',
    rusWord:'Россия',
    correct:false
  },
  {
    engWord:'France',
    rusWord:'Франция',
    correct:false
  },
  {
    engWord:'Germany',
    rusWord:'Германия',
    correct:false
  },
  {
    engWord:'USA',
    rusWord:'США',
    correct:false
  },
  {
    engWord:'Japan',
    rusWord:'Япония',
    correct:false
  },
  {
    engWord:'China',
    rusWord:'Китай',
    correct:false
  }
]

// Lesson 1_2
export const snakeDataSet3 = [
  {
    engWord:'Actor',
    rusWord:'Актёр',
    correct:false
  },
  {
    engWord:'Acrobat',
    rusWord:'Акробат',
    correct:false
  },
  {
    engWord:'President',
    rusWord:'Президент',
    correct:false
  },
  {
    engWord:'Minister',
    rusWord:'Министер',
    correct:false
  },
  {
    engWord:'Performer',
    rusWord:'Артист ',
    correct:false
  },
  {
    engWord:'Ballet dancer',
    rusWord:'Балерина',
    correct:false
  },
  {
    engWord:'Сhauffeur',
    rusWord:'Шофёр',
    correct:false
  }
]

// Lesson 1_2
export const snakeDataSet4 = [
  {
    engWord:'famous',
    rusWord:'известный',
    correct:false
  },
  {
    engWord:'I earn',
    rusWord:'Я зарабатываю',
    correct:false
  },
  {
    engWord:'President',
    rusWord:'Президент',
    correct:false
  },
  {
    engWord:'Capital',
    rusWord:'Столица',
    correct:false
  },
  {
    engWord:'More than',
    rusWord:'более',
    correct:false
  },
  {
    engWord:'first',
    rusWord:'первый',
    correct:false
  },
  {
    engWord:'served',
    rusWord:'служил',
    correct:false
  },
  {
    engWord:'total',
    rusWord:'всего',
    correct:false
  },
  {
    engWord:'I drive',
    rusWord:'я вожу',
    correct:false
  },
  {
    engWord:'Yellow',
    rusWord:'Жёлтый',
    correct:false
  },
  {
    engWord:'Taxi',
    rusWord:'Такси',
    correct:false
  }
]

// Lesson 1_3
export const snakeDataSet5 = [
  {
    engWord:'professional',
    rusWord:'профессиональный',
    correct:false
  },
  {
    engWord:'country',
    rusWord:'страна',
    correct:false
  },
  {
    engWord:'in my country',
    rusWord:'в моей стране',
    correct:false
  },
  {
    engWord:'people',
    rusWord:'люди',
    correct:false
  },
  {
    engWord:'very',
    rusWord:'очень',
    correct:false
  },
  {
    engWord:'they love',
    rusWord:'любят',
    correct:false
  },
  {
    engWord:'our',
    rusWord:'наши',
    correct:false
  },
  {
    engWord:'just',
    rusWord:'просто',
    correct:false
  },
  {
    engWord:'mad',
    rusWord:'бешеные',
    correct:false
  }
]

// Lesson 2_1
export const snakeDataSet6 = [
  {
    engWord:'restaurant',
    rusWord:'ресторан',
    correct:false
  },
  {
    engWord:'cafe',
    rusWord:'кафе',
    correct:false
  },
  {
    engWord:'food-court',
    rusWord:'фуд-корт',
    correct:false
  },
  {
    engWord:'cafeteria',
    rusWord:'кафетерий',
    correct:false
  },
  {
    engWord:'pizzeria',
    rusWord:'пиццерия',
    correct:false
  },
  {
    engWord:'coffeeshop',
    rusWord:'кофешоп',
    correct:false
  },
  {
    engWord:'bar',
    rusWord:'бар',
    correct:false
  },
  {
    engWord:'canteen',
    rusWord:'столовая',
    correct:false
  }
]

export const snakeDataSet7 = [
  {
    engWord:'hospital',
    rusWord:'больница',
    correct:false
  },
  {
    engWord:'parliament',
    rusWord:'парламент',
    correct:false
  },
  {
    engWord:'office',
    rusWord:'офис',
    correct:false
  },
  {
    engWord:'school',
    rusWord:'школа',
    correct:false
  },
  {
    engWord:'university',
    rusWord:'университет',
    correct:false
  },
  {
    engWord:'bank',
    rusWord:'банк',
    correct:false
  },
  {
    engWord:'theatre',
    rusWord:'театр',
    correct:false
  }
]

export const snakeDataSet8 = [
  {
    engWord:'banker',
    rusWord:'банкир',
    correct:false
  },
  {
    engWord:'secretary',
    rusWord:'секретарь',
    correct:false
  },
  {
    engWord:'teacher',
    rusWord:'учитель',
    correct:false
  },
  {
    engWord:'deputy',
    rusWord:'депутат',
    correct:false
  },
  {
    engWord:'professor',
    rusWord:'профессор',
    correct:false
  },
  {
    engWord:'doctor',
    rusWord:'доктор',
    correct:false
  },
  {
    engWord:'actor',
    rusWord:'актёр',
    correct:false
  }
]